// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms {
  overflow: scroll;
}

ion-item {
  cursor: pointer;
  height: 60px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
ion-item h2 {
  font-family: var(--font);
  font-weight: 600;
}

ion-item:last-child {
  border-bottom: none;
}

.background {
  min-height: 93vh !important;
}
.background p {
  font-family: var(--font);
  font-weight: 400;
}

ion-icon {
  width: 1.5rem;
  height: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/terms-n-privacy/terms-n-privacy.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,4CAAA;AAEJ;AADI;EACI,wBAAA;EAA0B,gBAAA;AAIlC;;AADA;EACI,mBAAA;AAIJ;;AAFA;EACI,2BAAA;AAKJ;AAJI;EACI,wBAAA;EAA0B,gBAAA;AAOlC;;AAJA;EACI,aAAA;EACA,cAAA;AAOJ","sourcesContent":[".terms {\n    overflow: scroll;\n}\nion-item{\n    cursor: pointer;\n    height: 60px;\n    display: flex;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    h2{\n        font-family: var(--font); font-weight: 600;;\n    }\n}\nion-item:last-child{\n    border-bottom: none;\n}\n.background{\n    min-height: 93vh !important;\n    p{\n        font-family: var(--font); font-weight: 400;;\n    }\n}\nion-icon{\n    width: 1.5rem;\n    height: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
